import { useContext, useEffect } from "react";
import constants from "src/constants";
import { UserContext } from "src/contexts/UserContext";

export default function Footers() {
  const { loggedUser } = useContext(UserContext);

  useEffect(() => {
    const isScriptRendered = document.getElementById("usercom") === null;

    if (
      process.env.NODE_ENV !== "development" &&
      loggedUser !== null &&
      isScriptRendered
    ) {
      const loadUserData = () => {
        const externalScript = document.createElement("script");
        externalScript.id = "usercom";
        // externalScript.async = false;
        externalScript.innerHTML = loggedUser
          ? `window.civchat = {
          apiKey: "${constants.Api.UserComApiKey}",
          email: "${loggedUser?.user.email}",
          user_id: "${loggedUser?.user.id}",
          name: "${loggedUser?.name === null ? "New" : loggedUser?.name} ${
              loggedUser?.surname === null ? " user" : loggedUser?.surname
            }",
          phone_number: "${
            loggedUser?.phone === null ? "-" : loggedUser?.phone
          }",
        };`
          : `window.civchat = {
          apiKey: "${constants.Api.UserComApiKey}",
        };`;

        externalScript.type = "text/javascript";
        document.body.appendChild(externalScript);
      };

      const loadWidget = () => {
        const externalScript = document.createElement("script");
        // externalScript.async = false;
        externalScript.type = "text/javascript";
        externalScript.src = constants.Paths.userComWidget;
        document.body.appendChild(externalScript);
      };

      loadUserData();
      loadWidget();
    }
  }, [loggedUser]);

  return <></>;
}
